import React from 'react';
import styled from 'styled-components';

import Icon from '../Icon';

const Container = styled.div.attrs({
  className: 'flex items-center',
})``;
const Bar = styled.div.attrs({
  className: 'rounded-full bg-gray-800 flex-grow relative',
})`
  height: ${(props) => props.height}px;
  ${(props) =>
    props.hasBorder &&
    `
    border: 2px solid #edeeff;
  `}
`;
const FilledBar = styled.div.attrs({
  className: 'rounded-full bg-light-yellow',
})`
  width: ${(props) => props.value}%;
  height: 100%;
`;
const Indicator = styled.div.attrs({
  className:
    'rounded-full border-2 border-solid border-white bg-primary absolute w-4 h-4',
})`
  left: calc(${(props) => props.pos}% - 8px);
  top: -5px;
`;

const ProgressBar = ({
  value,
  hasStar = false,
  showStar = false,
  showPercent = false,
  hasBorder = false,
  height = 8,
}) => (
  <Container>
    <Bar height={height} hasBorder={hasBorder}>
      <FilledBar value={value} />
      {/* <Indicator pos={value} /> */}
    </Bar>
    {showPercent && (
      <span className="ml-2 text-secondary text-base leading-5">{value}%</span>
    )}
    {(hasStar || showStar) && (
      <Icon
        className="ml-1"
        name={(showStar && 'star') || ''}
        color="#ffc85f"
        size={14}
      />
    )}
  </Container>
);

export default ProgressBar;
